const GET_APPROVAL_LIST_ASSIGNMENT = "GET_APPROVAL_LIST_ASSIGNMENT"
const SET_APPROVAL_LIST_ASSIGNMENT = "SET_APPROVAL_LIST_ASSIGNMENT"

const GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT = "GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT"
const SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT = "SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT"

const SAVE_APPROVAL_LIST_ASSIGNMENT = "SAVE_APPROVAL_LIST_ASSIGNMENT"
const IS_APPROVAL_LIST_SAVED = "IS_APPROVAL_LIST_SAVED"

const GET_APPROVAL_LIST_EXCEL_DATA = "GET_APPROVAL_LIST_EXCEL_DATA"
const SET_APPROVAL_LIST_EXCEL_DATA = "SET_APPROVAL_LIST_EXCEL_DATA"

const GET_All_APPROVAL_LIST_EXCEL_DATA = "GET_All_APPROVAL_LIST_EXCEL_DATA"
const SET_All_APPROVAL_LIST_EXCEL_DATA = "SET_All_APPROVAL_LIST_EXCEL_DATA"

const VALIDATE_APPROVAL_LIST_ASSIGNMENT = "VALIDATE_APPROVAL_LIST_ASSIGNMENT"
const IS_APPROVAL_LIST_VALIDATED = "IS_APPROVAL_LIST_VALIDATED"

export{
    GET_APPROVAL_LIST_ASSIGNMENT,
    SET_APPROVAL_LIST_ASSIGNMENT,
    GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT,
    SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT,
    SAVE_APPROVAL_LIST_ASSIGNMENT,
    IS_APPROVAL_LIST_SAVED,
    GET_APPROVAL_LIST_EXCEL_DATA,
    SET_APPROVAL_LIST_EXCEL_DATA,
    GET_All_APPROVAL_LIST_EXCEL_DATA,
    SET_All_APPROVAL_LIST_EXCEL_DATA,
    VALIDATE_APPROVAL_LIST_ASSIGNMENT,
    IS_APPROVAL_LIST_VALIDATED
}